<app-base-card
  [borderColor]="
    order.inTransit
      ? '#007bff'
      : order.takeawayPriceTotal
      ? '#01894d'
      : '#eaecf0'
  "
>
  <section class="border-bottom pointer" (click)="goToDetails(order.id)">
    <div class="d-flex justify-content-between align-items-center">
      <p
        *ngIf="order?.orderType === 'DELIVERY' && order?.customerDetails"
        class="mb-0 fw-600 f-14 lh-20"
      >
        <img
          src="/assets/icons/external-delivery.svg"
          alt="External delivery"
        />
        &nbsp; External delivery
      </p>
      <p *ngIf="order?.orderType === 'DINE_IN'" class="mb-0 fw-600 f-14 lh-20">
        {{ order.table }}
      </p>
      <p *ngIf="order?.table === 'TAKE_OUT'" class="mb-0 fw-600 f-14 lh-20">
        TAKE OUT
      </p>
      <p class="mb-0 fw-600 lh-24">
        {{ order.totalAmount | currency : '₦' }}
      </p>
    </div>
    <div
      *ngIf="order.inTransit"
      class="d-flex justify-content-between align-items-center mt-2"
    >
      <p class="mb-0 fw-600 f-14 lh-20 text-primary">Reservation Time</p>
      <p class="mb-0 fw-600 f-14 lh-20 text-primary">
        {{ order.reservationStartTime | date : 'short' }} -
        {{ order.reservationEndTime | date : 'short' }}
      </p>
    </div>
    <!-- Countdown Timer -->
    <div
      *ngIf="showCountdown"
      class="d-flex justify-content-center align-items-center mt-2 p-2"
      [ngClass]="
        countdownText === 'EXPIRED'
          ? 'bg-danger text-white'
          : 'bg-warning text-dark'
      "
      style="border-radius: 8px"
    >
      <p class="mb-0 fw-700 f-16 lh-20">
        <span *ngIf="countdownText !== 'EXPIRED'"
          >⏰ Ending in: {{ countdownText }}</span
        >
        <span *ngIf="countdownText === 'EXPIRED'">⚠️ RESERVATION EXPIRED</span>
      </p>
    </div>
    <p class="text__grey-600 mt-1 f-14 fw-400">
      {{ getObjectLength(order.dishes) }}
      {{ getObjectLength(order.dishes) > 1 ? 'dishes' : 'dish' }}
    </p>
    <div
      class="d-flex justify-content-between align-items-center"
      *ngIf="order.takeawayPriceTotal"
    >
      <p class="mb-0 fw-600 f-14 lh-20">Takeaway price</p>
      <p class="mb-0 fw-600 lh-24">
        {{ order.takeawayPriceTotal | currency : '₦' }}
      </p>
    </div>
  </section>

  <section
    class="meal border-bottom py-3 pointer"
    (click)="goToDetails(order.id)"
  >
    <ng-container *ngFor="let item of order.dishes | keyvalue">
      <ng-container *ngFor="let meal of item.value; last as isLast">
        <div class="d-flex flex-column justify-content-between gap-2 mb-2">
          <div class="gap-8 d-flex align-items-center mb-2">
            <div class="food__img">
              <img
                *ngIf="isImageValid(meal.imageUrl)"
                [src]="meal?.imageUrl"
                [alt]="meal.name"
                style="height: 20px"
              />
              <img
                *ngIf="!isImageValid(meal.imageUrl)"
                src="/assets/images/no-food-img.svg"
                [alt]="meal.name"
              />
            </div>
            <p class="mb-0 lh-24 fw-400 text__grey-500">
              &#215;{{ meal?.quantity }}
            </p>
            <p class="mb-0 lh-24 fw-400 text__grey-800 text-capitalize">
              {{ meal?.name }}
              <span *ngIf="meal?.takeawayPrice" class="text__grey-500 f-12 ms-2"
                >(Takeout)</span
              >
            </p>
          </div>
          <div *ngIf="meal?.addons?.length! > 0">
            <p class="text__grey-500 mb-0 f-14 fw-400">Addon</p>
            <div class="d-flex gap-8">
              <p
                *ngFor="let addon of meal?.addons"
                class="text__grey-500 mb-0 f-14 fw-400"
              >
                <!-- &#43; {{ meal?.addons?.length }} &nbsp; add-on -->

                {{ addon.name }}
              </p>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- <p
      *ngIf="getObjectLength(order.dishes) > 2"
      class="text__grey-500 fw-400 f-14 lh-20 mb-0 mt-3"
    >
      &#43; {{ getObjectLength(order.dishes) - 2 }} more
      {{ getObjectLength(order.dishes) - 2 === 1 ? 'item' : 'items' }}
    </p> -->
    <p class="text__grey-500 fw-400 f-14 lh-20 mb-0 mt-3">View more details</p>
    <Section
      *ngIf="order.specialRequest"
      class="text__grey-500 fw-400 f-14 lh-20 mb-0 mt-3"
    >
      <div class="d-flex justify-content-between align-items-center">
        <p class="text__grey-700 fw-600 f-14 lh-20 mb-0 mt-3">Customer notes</p>
        <img src="/assets/icons/gif.svg" alt="info" class="bounce-animation" />
      </div>

      <div
        style="
          background-color: #fef0c7;
          border: 1px solid #fedf89;
          padding: 12px;
          border-radius: 8px;
          margin-top: 8px;
        "
      >
        <p class="text__grey-500 fw-600 f-14 lh-20 mb-0">
          {{ order.specialRequest }}
        </p>
      </div>
    </Section>
  </section>
  <section class="action mt-3">
    <div class="d-flex justify-content-between align-items-center">
      <div class="gap-8 d-flex align-items-center">
        <img src="/assets/icons/clock.svg" alt="timer" />
        <p class="mb-0 lh-20 f-14">
          {{ order.updatedTime | dateAgo }}
        </p>
      </div>
      <div>
        <app-base-button
          *ngIf="['NEW', 'ACCEPTED'].includes(order.status)"
          (click)="handleOrderUpdate.emit(order)"
          [label]="order.status === 'NEW' ? 'Accept' : 'Mark as ready'"
          [colorClasses]="
            'custom__btn custom__btn-brand custom-btn-lg w-unset fw-600 lh-24 p-12-20'
          "
        ></app-base-button>
      </div>
    </div>
    <div class="mt-3" *ngIf="['NEW', 'ACCEPTED', 'READY'].includes(order.status)">
      <button
        class="print-btn w-100"
        (click)="printOrder($event)"
        title="Print Order"
      >
        Print Order
      </button>
    </div>
  </section>
</app-base-card>
